import React, {useState} from 'react';
import ErrorLayer from '@core/scripts/components/layers/ErrorLayer.jsx';
import Landmark from '@core/scripts/components/landmark-adapter';

export default function FacadeFailureLayer({
    texts = {
        headline: 'bff_fs_facade_failure_headline',
        contact: 'bff_fs_facade_failure_contact',
    },
}) {
    const [open, setOpen] = useState(true);

    const close = () => {
        Landmark.sendClickLandmark('close_errorlayer');
        setOpen(false);
    };

    return (
        <ErrorLayer className="error-layer__table" open={open} onClose={close}>
            <div className="facade-failure__headline">{texts.headline}</div>
            <div className="facade-failure__content">
                <p className="facade-failure__contact" dangerouslySetInnerHTML={{__html: texts.contact}} />
            </div>
        </ErrorLayer>
    );
}
